import type { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';
import type { IEpisodeCategoryBasic } from '@common/interfaces';
import { translatePatientTaskType } from '@frontend/translate/custom';

export function getPatientTaskDescriptionOrType(
    task: Pick<OutpatientClinicTask, 'description'> & {
        type: Pick<OutpatientClinicTask['type'], 'name'>;
    },
    episodeCategory: Pick<IEpisodeCategoryBasic, 'name'>
): string {
    return task.description ?? translatePatientTaskType(episodeCategory.name, task.type.name);
}
